import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/`;

export const fetchCustomPoints = createAsyncThunk(
  "badges/fetchCustomPoints",
  async (organization_id, { rejectWithValue }) => {
    try {
      const jwtToken = localStorage.getItem("jwt_token");
      const response = await axios.get(
        `${API_URL}badges/custom-points/${organization_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const badgesSlice = createSlice({
  name: "badges",
  initialState: {
    customPoints: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCustomPoints: (state) => {
      state.customPoints = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomPoints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomPoints.fulfilled, (state, action) => {
        state.loading = false;
        state.customPoints = action.payload;
      })
      .addCase(fetchCustomPoints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCustomPoints } = badgesSlice.actions;
export default badgesSlice.reducer;
